module.exports = __webpack_public_path__ + "static/media/platform.0800b223.png";